import React, { useState, useContext } from "react";
import globalContext from "./globalContext";
import Util from "../util/util";
import api from "../util/api";
import ComponentContainer from "./componentContainer";
import AlertDialog from "./alertdialog";
import ErrorIcon from '@mui/icons-material/Error';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Button, ClickAwayListener, FormControl, Grid, IconButton, InputAdornment, List, ListItem, ListItemText, Modal, Paper, TextField, Typography } from "@mui/material";
import ClassIcon from '@material-ui/icons/Class';
import AddEditDelForm from "./addEditDelForm";
import { TextFieldsRounded } from "@mui/icons-material";
import AutocompleteAsync from "../controls/autocompleteasync";
import KPDKlasifikacijaForm from "./kpdKlasifikacijaForm";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'white',
    border: '2px solid #000',
    p: 6,
    maxHeight: '80%',
    minWidth: '70%'
};

export default function KPDKlasifikacija(props) {

    const useConstructor = Util.useConstructor();
    const global = useContext(globalContext);

    const [loading, setLoading] = useState(true);
    const [firmaKPDs, setFirmaKPDs] = useState([]);
    const [selectedFirmaKPD, setSelectedFirmaKPD] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const [searchText, setSearchText] = useState("");
    const [formOpened, setFormOpened] = useState(false);
    const [deleteAlert, setDeleteAlert] = useState(false);

    useConstructor(() => {
        loadKPDs();
    });

    function loadKPDs() {
        api.get("kpd/getforfirma?firmaID=" + global.user.firmaID, loadKPDsSuccess, loadKPDsFail);
    }

    function loadKPDsSuccess(data) {
        setFirmaKPDs(data);
        setLoading(false);
    }

    function loadKPDsFail(data) {
        setErrorMessage(data ? (data.Message || data.toString()) : "");
        setLoading(false);
    }

    function deleteConfirmed() {
        setLoading(true);
        api.get("kpd/delete?firmaKPDKlasifikacijaID=" + selectedFirmaKPD.FirmaKPDKlasifikacijaID, deleteSuccess, deleteFail);
    }

    function deleteSuccess() {
        loadKPDs();
    }

    function deleteFail(data) {
        setDeleteAlert(false);
        setErrorMessage(data ? (data.Message || data.toString()) : "");
        setLoading(false);
    }

    return (
        <ComponentContainer loading={loading || global.loading}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h4" gutterBottom component="div" style={{marginBottom:"15px"}}>
                        <ClassIcon fontSize="medium" style={{marginRight:"15px"}}></ClassIcon>
                        KPD klasifikacija
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Box display="flex" style={{width:"100%", marginBottom:"5px"}} justifyContent="space-around">
                        <IconButton aria-label="search" style={{width: "5%"}} onClick={() => setSearchText("")}>
                            <CloseIcon style={{ fill: "#1976d2" }} />
                        </IconButton>
                        <TextField
                            label="Pretraži" 
                            variant="standard" 
                            style={{width: "95%"}}
                            onChange={(e) => setSearchText(e.target.value)} 
                            value={searchText}
                            InputProps={{
                                endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon />
                                </InputAdornment>
                                ),
                            }}>                     
                        </TextField>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Box style={{width:"100%"}}>
                        <ListItem className="list-title" key="kpds-title" style={{backgroundColor:"lightblue"}}>
                            <Grid container spacing={1}>
                                <Grid item xs={2}>
                                    <ListItemText style={{paddingLeft:"15px"}} primaryTypographyProps={{ noWrap:true }} primary="Oznaka" ></ListItemText>
                                </Grid>
                                <Grid item xs={10}>
                                    <ListItemText style={{paddingLeft:"15px"}} primaryTypographyProps={{ noWrap:true }} primary="Opis" ></ListItemText>
                                </Grid>
                            </Grid>
                        </ListItem>
                        <Paper variant="outlined" style={{width:"100%", maxHeight: 350, overflow: 'auto'}}>
                            <List dense>
                                {firmaKPDs.filter(kpd => kpd.KPDKlasifikacija.Oznaka.toUpperCase().includes(searchText.toUpperCase()) || kpd.KPDKlasifikacija.Opis.toUpperCase().includes(searchText.toUpperCase())).map((kpd, index) => {
                                    return <ListItem className="list-item" key={"kpd" + index} style={{paddingTop:0, paddingBottom:0}}  onClick={() => setSelectedFirmaKPD(kpd)} >
                                            <Grid container spacing={1}>
                                                <Grid item xs={2}>
                                                    <ListItemText style={{paddingLeft:"15px"}} primaryTypographyProps={{ noWrap:true, fontWeight: kpd == selectedFirmaKPD ? 700 : 400 }} primary={kpd.KPDKlasifikacija.Oznaka} ></ListItemText>
                                                </Grid>
                                                <Grid item xs={10}>
                                                    <ListItemText style={{paddingLeft:"15px"}} primaryTypographyProps={{ noWrap:true, fontWeight: kpd == selectedFirmaKPD ? 700 : 400 }} primary={kpd.KPDKlasifikacija.Opis} ></ListItemText>
                                                </Grid>
                                            </Grid>
                                        </ListItem>
                                })}
                            </List>
                        </Paper>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Box style={{width:"100%"}} display="flex" sx={{display:{ xs:"none", sm:"none", md:"flex" }, justifyContent:"flex-end"}}  marginTop="10px">
                        <Button variant="contained" color="success" startIcon={<AddIcon></AddIcon>} style={{marginRight:"5px"}}  onClick={() => setFormOpened(true)}>&nbsp;Dodaj</Button>
                        <Button variant="contained" color="error" startIcon={<DeleteIcon></DeleteIcon>} style={{marginRight:"5px"}} disabled={!selectedFirmaKPD || loading}  onClick={() => setDeleteAlert(true)}>&nbsp;Ukloni</Button>
                    </Box>
                </Grid>
            </Grid>

            <Modal open={formOpened}>
                <Box sx={style} overflow={"auto"} >
                    <KPDKlasifikacijaForm setFormOpened={setFormOpened} reload={loadKPDs}></KPDKlasifikacijaForm>
                </Box>
            </Modal>

            {deleteAlert ? <AlertDialog title="Uklanjanje KPD klase" message={"Jeste li sigurni da želite ukloniti odabranu KPD klasu?"} cancelLabel={"Odustani"} confirmLabel={"Ukloni"} cancelAction={() => {setDeleteAlert(false);}} confirmAction={deleteConfirmed}></AlertDialog> : null}

            {errorMessage != null && errorMessage != "" ? <AlertDialog title="Greška" icon={<ErrorIcon style={{marginRight:"15px", color:"red"}}></ErrorIcon>} message={errorMessage} cancelHidden={false} confirmHidden={true} okHidden={true} cancelLabel={"Zatvori"} cancelAction={() => setErrorMessage("")}></AlertDialog> : null}
        </ComponentContainer>
    );
}